




























import Vue from "vue";

export default Vue.extend({
  name: "TimepIcker",
   props: {
    time: String
  },
  data: () => ({
    menu2: false
  }),
  watch: {
    time: function(val) {
      this.$emit("timeSelected", val);
    }
  }
});
